import { SettlementStateEvent } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { startCase } from 'lodash-es';

export const getSettlementStateEventLabel = (stateEvent: SettlementStateEvent) => {
  switch (stateEvent) {
    case SettlementStateEvent.APPROVE:
      return t('approvals.driver_pay.settlements.state_events.approve');
    case SettlementStateEvent.CUSTOMER_PAY:
      return t('approvals.driver_pay.settlements.state_events.customer_pay');
    case SettlementStateEvent.PAY:
      return t('approvals.driver_pay.settlements.state_events.pay');
    case SettlementStateEvent.SEND_SETTLEMENT:
      return t('approvals.driver_pay.settlements.state_events.send_settlement');
    case SettlementStateEvent.UNDO_PAY:
      return t('approvals.driver_pay.settlements.state_events.undo_pay');
    default:
      return startCase(stateEvent);
  }
};
